import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SearchServiceProvider } from '../contract/providers/search-service-provider.contract';

@Injectable()
export class SearchService implements SearchServiceProvider {
  private _searchTerms = new BehaviorSubject('');

  readonly searchTerm$ = this._searchTerms.asObservable();

  getSearchTerm(): string {
    return this._searchTerms.getValue();
  }
  searchTermChange(term: string): void {
    this._searchTerms.next(term);
  }
}
